import { useEffect } from 'react';
import GuestLayout from '../../Layouts/GuestLayout';
import LoginBox from '../../Components/LoginBox';
import InputError from '../../Components/InputError';
import InputLabel from '../../Components/InputLabel';
import TextInput from '../../Components/TextInput';
import AuthButton from '../../Components/AuthButton';
import { Head, Link, useForm } from '@inertiajs/react';

export default function ResetPassword({ token, email }) {
    const { data, setData, post, processing, errors, reset } = useForm({
        token: token,
        email: email,
        password: '',
        password_confirmation: '',
    });

    useEffect(() => {
        return () => {
            reset('password', 'password_confirmation');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();

        post(route('password.storelink'));
    };

    return (
        <GuestLayout>
            <Head title="Reset Password" />

            <LoginBox>
                <div className="w-full px-6 py-3 drop-shadow-md">

                    <div>
                        <div className="mt-4 text-left lg:mt-2">
                            <div className="inline-flex items-center w-full">
                            <h3 className="text-lg mx-auto font-medium text-slate-500 leading-6 uppercase">Reset your password</h3>
                            </div>
                        </div>
                    </div>

                    <form onSubmit={submit}>
                        <div className="mt-6 space-y-4">
                            <div>
                                <InputLabel className="sr-only" htmlFor="email" value="Email" />

                                <TextInput
                                    id="email"
                                    type="email"
                                    name="email"
                                    value={data.email}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Enter your email"
                                    autoComplete="email"
                                    isFocused={true}
                                    onChange={(e) => setData('email', e.target.value)}
                                />

                                <InputError message={errors.email} className="mt-2" />

                            </div>

                            <div>
                                <InputLabel className="sr-only" htmlFor="password" value="Password" />

                                <TextInput
                                    id="password"
                                    type="password"
                                    name="password"
                                    value={data.password}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Enter new password"
                                    autoComplete="current-password"
                                    onChange={(e) => setData('password', e.target.value)}
                                />

                                <InputError message={errors.password} className="mt-2" />
                            </div>

                            <div>
                                <InputLabel className="sr-only" htmlFor="password_confirmation" value="Confirm Password" />

                                <TextInput
                                    id="password_confirmation"
                                    type="password"
                                    name="password_confirmation"
                                    value={data.password_confirmation}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Confirm your password"
                                    autoComplete="new-password"
                                    onChange={(e) => setData('password_confirmation', e.target.value)}
                                />

                                <InputError message={errors.password_confirmation} className="mt-2" />
                            </div>

                            <div className="flex flex-col mt-4 lg:space-y-4">
                                <AuthButton disabled={processing}>
                                    Reset Password
                                </AuthButton>

                                <span className="mx-auto">
                                        <Link
                                            href={route('signin')}
                                            className="underline text-sm inline-flex justify-center py-4 font-medium text-slate-500 focus:outline-none hover:text-neutral-600 focus:text-slate-600 sm:text-sm"
                                        >
                                            Back to login
                                        </Link>
                                </span>
                            </div>
                        </div>
                    </form>

                </div>

            </LoginBox>

        </GuestLayout>
    );
}
